var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('categoria-update',{attrs:{"categoria":_vm.categoria},on:{"cerrar-dialog":function($event){return _vm.$emit('cerrar-dialog')},"update-category":_vm.actualizarCategoria}})}
var staticRenderFns = []

export { render, staticRenderFns }